import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { ApiResourceState, QueryParams } from '../types/contracts';

export function useApiResource<T>(path: string, params?: QueryParams): ApiResourceState<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const serializedParams = JSON.stringify(params || {});

  useEffect(() => {
    let isActive = true;
    const requestParams = serializedParams ? (JSON.parse(serializedParams) as QueryParams) : undefined;

    const fetchResource = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await api.get<T>(path, { params: requestParams });
        if (!isActive) return;
        setData(response.data);
      } catch (err) {
        if (!isActive) return;
        console.error(`Error fetching ${path}:`, err);
        setData(null);
        setError('load_failed');
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchResource();

    return () => {
      isActive = false;
    };
  }, [path, serializedParams]);

  return { data, loading, error };
}
